import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";
import { ulid } from "./commonFields";
import { nonNegativeIntegerStringSchema } from "./commonFields/numberSchema";

const agreementType = dictionary.extend({
  valid_from: z.string().date(),
  valid_to: z.string().date(),
  company_id: ulid,
  company_name: z.string(),
  template_code: z.string().min(1),
  active: z.boolean(),
  sort_order: z.coerce.string().pipe(nonNegativeIntegerStringSchema),
  contest_regulations_required: z.boolean(),
  is_b2b: z.boolean(),
});

export const agreementTypeRead = agreementType.readonly();
export const agreementTypeCreate = agreementType.omit({
  id: true,
  company_name: true,
});
export const agreementTypeUpdate = agreementTypeCreate.partial();
